import { Group, Text, Box, ActionIcon } from "@mantine/core";
import React from "react";

import { IconInfoCircle } from "@tabler/icons-react";
import { Cubby } from "../../stores/Cubby";
type TextWithInfoProps = {
  text: string;
  cubby: Cubby;
  icon: React.ReactNode;
  articleSlug: string;
  textSize?: string;
  infoCircleNudge?: {
    vertical?: number;
    horizontal?: number;
  };
};

export const TextWithInfoAndIcon: React.FC<TextWithInfoProps> = ({
  text,
  articleSlug,
  icon,
  cubby,
  textSize = "md",
  infoCircleNudge = { vertical: 2, horizontal: -3 },
}) => (
  <Group gap="xs" justify="flex-start" wrap="nowrap">
    {icon}
    <Text size={textSize}>{text}</Text>

    <ActionIcon
      variant="subtle"
      size="sm"
      component="a"
      target="_blank"
      mt={infoCircleNudge.vertical}
      ml={infoCircleNudge.horizontal}
      onClick={() => cubby.setCurrentlyFocusedArticleSlug(articleSlug)}
      style={{
        color: "var(--mantine-color-dark-3)",
        marginLeft: "10rem",
      }}
      aria-label="Info"
    >
      <IconInfoCircle size={22} />
    </ActionIcon>
  </Group>
);
